<template>
	<div
		class="
		     h-full bg-white border-r border-[#E9EEF2] px-4 py-5
            flex flex-col relative z-[10] transition-all overflow-y-auto sidebar
        "
        :class="collapsed ? 'w-fit' : 'w-full max-w-[220px]'"
	>
		<div
			class="flex items-center cursor-pointer justify-between w-full"
		>
		    <div
				class="flex items-center justify-between w-full mb-5"
				v-if="showCollapseButton"
			>
				<div
					@click="handleHome"
					:class="collapsed ? 'max-w-10' : 'w-auto'"
				>
					<img
						class="h-6"
						v-if="['networking-tool-favorites', 'networking-tool'].includes(route.name)"
						src="/img/logo_networking_ai.svg?id=36d75e6e63946874eae5"
						alt="NetworkingAI"
					/>
					<img
						class="w-auto h-6"
						v-else-if="route.name === 'services-tracker'"
						src="/img/logo_services.svg?id=36d75e6e63946874eae5"
						alt="Client Portal"
					/>
					<img
						class="w-auto h-6"
						v-else
						:src="collapsed ? '/img/logo-mini.svg?id=36d75e6e63946874eae5' : '/img/logo.svg?id=36d75e6e63946874eae5'"
					/>
				</div>

				<ClipSidebarIcon
					class="cursor-pointer rotate-180"
					v-if="!collapsed"
					@click="sidebarStore.sidebarCollapseHandler"
				/>
			</div>
		</div>
		
        <div class="flex flex-col justify-between h-full gap-6">
            <div class="w-full">
                <div
                    class="mb-2.5 flex"
                    :class="collapsed ? 'justify-center' : 'justify-end'"
                    v-if="collapsed || route.name === 'resumes.edit'"
                >
                    <ClipSidebarIcon
                        class="cursor-pointer"
                        :class="[collapsed ? '' : 'rotate-180' ]"
                        v-if="showCollapseButton"
                        @click="sidebarStore.sidebarCollapseHandler"
                    />
                </div>
    
                <div v-if="route.name === 'services-tracker'">
                    <a href="https://www.wonsulting.com/services" target="_blank">
                        <won-button
                            v-tooltip="{ content: 'See our services', delay: { show: collapsed ? 500 : 999999, hide: 100 } }"
                            class="w-full"
                        >
                            {{ collapsed ? '' : 'See our services' }}
                        </won-button>
                    </a>
                </div>
    
                <won-button
                    v-tooltip="{ content: 'New Application', delay: { show: collapsed ? 500 : 999999, hide: 100 } }"
                    @click="showApplicationModal"
                    v-else-if="['auto-apply-jobs', 'auto-apply'].includes(activeRoute)"
                    class="w-full"
                >
                    <div
                        data-step="1"
                        id="find-jobs-button"
                        class="absolute w-full h-10"
                    />
                    +{{ collapsed ? '' : ' Find Jobs' }}
                </won-button>
                
                <won-button 
                    v-tooltip="{ content: 'Start New Interview', delay: { show: collapsed ? 500 : 999999, hide: 100 } }"
                    id="create-new-interview"
                    @click="startNewInterviewHandler"
                    v-else-if="['interview-ai', 'interview-ai-interviews', 'interview-ai-create'].includes(activeRoute)"
                    class="w-full"
                >
                    +{{ collapsed ? '' : ' Start New Interview' }}
                </won-button>
     
                 <div
                     v-else-if="!['cover-letters.index', 'cover-letters.edit', 'home'].includes(activeRoute)"
                     class="cursor-pointer"
                     @click="createNewResumeHandler"
                 >
                    <won-button
                        v-tooltip="{content: 'Create New Resume', delay: { show: collapsed ? 500 : 999999, hide: 100 }}"
                        class="w-full focus:outline-0 whitespace-nowrap"
                    >
                        +{{ collapsed ? '' : ' Create New Resume' }}
                     </won-button>
                 </div>
    
                <div v-else-if="activeRoute !== 'home'" class="cursor-pointer" @click="emit('new-resource')">
                    <won-button
                        v-tooltip="{content: 'New Cover Letter', delay: { show: collapsed ? 500 : 999999, hide: 100 }}"
                        class="w-full focus:outline-0">
                        +{{ collapsed ? '' : ' Create New Cover Letter' }}
                    </won-button>
                </div>
     
                <upload-resume
                    v-if="
                        getCurrentVersion() >= 4 && ![
                            'auto-apply-jobs',
                            'auto-apply',
                            'interview-ai',
                            'interview-ai-create',
                            'interview-ai-interviews',
                            'home'
                        ].includes(activeRoute)
                    "
                    :collapsed="collapsed"
                />
                    
                <div
                    class="sidebar-divider"
                    v-if="activeRoute !== 'home'"
                />
    
                <div class="flex flex-col gap-0.5">
                    <sidebar-menu
                        :activeRoute="activeRoute"
                        :links="links.filter(el => el?.visible ?? true)"
                        :collapsed="collapsed"
                    />
                </div>
            </div>
            
            <div
                class="w-full flex flex-col gap-1"
                v-if="isAuthenticated()"
            >
                <div v-if="activeRoute !== 'resumes.edit' && !collapsed">
                    <!-- show job search plan step only on home page -->
                    <SidebarJobSearchPlanStep v-if="isJobSearchBlockersEnabled()"/>
                </div>
                
                <pdf-feature-usage-left
                    :collapsed="collapsed"
                />
                
                <pdf-tokens-left
                    v-if="!isSubscriptionModelActivated()"
                    v-tooltip="{ content: 'Tokens left', delay: { show: collapsed ? 500 : 999999, hide: 100 } }"
                    :collapsed="collapsed" />
                
                <pdf-referal
                    v-if="isReferralEnabled()"
                    v-tooltip="{ content: 'Refer Friends', delay: { show: collapsed ? 500 : 999999, hide: 100 } }"
                    @click="visibleReferalModal = true" :collapsed="collapsed"
                />
                
                <pdf-upgrade-button-sidebar
                    v-tooltip="{
                        content: 'Upgrade Plan',
                        delay: { show: collapsed ? 500 : 999999, hide: 100 }
                    }"
                    :collapsed="collapsed"
                />
    
                <div v-if="isSurveyEnabled()">
                    <div
                        :class="collapsed ? 'justify-center' : 'justify-start'"
                        class="flex py-1.5 px-2.5 items-center gap-1 cursor-pointer hover:bg-won-bg-blue rounded-[6px]"
                        @click="visibleSurvey = true"
                        v-tooltip="{ content: 'Go to Survey', delay: { show: collapsed ? 500 : 999999, hide: 100 } }"
                    >
                        <ChatBubbleBottomCenterTextIcon 
                            class="size-4 text-won-gray-blue"
                        />
                        
                        <span
                            class="text-sm font-medium ml-1 font-[Inter] text-won-gray-blue"
                            v-if="!collapsed"
                        >
                            Survey
                        </span>
                    </div>
    
                    <div
                        :class="collapsed ? 'justify-center' : 'justify-start'"
                        class="flex py-1.5 px-2.5 items-center gap-1 cursor-pointer hover:bg-won-bg-blue rounded-[6px]"
                      v-tooltip="{ content: 'Help', delay: { show: collapsed ? 500 : 999999, hide: 100 } }"
                        v-if="['resume-tool', 'cover-letters.index'].includes(activeRoute)" @click="handleOnboarding"
                    >
                        <help-icon />
                    </div>
                </div>
    
                <router-link v-tooltip="{ content: 'Log Out', delay: { show: collapsed ? 500 : 999999, hide: 100 } }"
                    :to="{ path: '/logout' }">
                    <div
                        :class="collapsed ? 'justify-center' : 'justify-start'"
                        class="flex py-1.5 px-2.5 items-center gap-1 cursor-pointer hover:bg-won-bg-blue rounded-[6px]"
                    >
                        <ArrowRightStartOnRectangleIcon class="size-4 text-won-gray-blue"/>
                        
                        <div v-if="!collapsed" class="text-sm font-medium ml-1 font-[Inter] text-won-gray-blue">
                            Log Out
                        </div>
                    </div>
                </router-link>
            </div>

	        <div
		        :class="collapsed ? 'justify-center' : 'justify-start'"
		        class="
		            flex py-1.5 px-2.5 items-center gap-1 cursor-pointer hover:bg-won-green-light
		            rounded-[6px] w-full h-10
				"
		        @click="authPopupStore.setShowAuthPopup"
		        v-else
	        >
		        <UserPlusIcon
			        class="size-5 text-won-gray-blue"
		        />

		        <div v-if="!collapsed" class="text-sm font-medium font-[Inter] text-won-gray-blue">
			        Sign Up / Log in
		        </div>
	        </div>
        </div>
	</div>

    <ReferalModal
        v-if="isReferralEnabled()"
        @delete-modal:close="visibleReferalModal = false"
        :visible="visibleReferalModal"
    />

    <SurveyModal
        :visible="visibleSurvey"
        link="https://docs.google.com/forms/d/e/1FAIpQLSccxfSiGYWW2gBvjLfZxBzcBoEmUU6OazNd-qupNWUeUEGLPg/viewform?usp=sf_link"
        @survey-modal:close="handleCloseSurvey()"
    />
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useRoute, useRouter } from 'vue-router'

import { setAuthState } from '../composables/auth'
import { useMenuItems } from "../composables/menu-items";
import {
    getCurrentVersion,
    isSubscriptionModelActivated,
    isReferralEnabled,
    isJobSearchBlockersEnabled,
    isSurveyEnabled
} from "../utils/helpers";

import { useSidebarStore } from '../store/sidebar.store';
import { useBulletGenerator } from '../store/bullet-store'
import { useSubscriptionPlanStore } from "../store/subscription.store";
import { useFeatureUsageStore } from "../store/feature-usage.store";
import { useAuthPopupStore } from "../store/auth-popup.store";

import WonButton from './won-button'
import UploadResume from './upload-resume'
import SidebarMenu from './sidebar-menu'
import SurveyModal from '../modals/survey'
import ReferalModal from '../modals/referal'
import PdfTokensLeft from './pdf-builder/pdf-tokens-left'
import PdfReferal from './pdf-builder/pdf-referal'
import PdfUpgradeButtonSidebar from './pdf-builder/pdf-upgrade-button-sidebar'
import PdfFeatureUsageLeft from "./pdf-builder/pdf-feature-usage-left.vue";
import SidebarOnboardingChecklist from "./onboarding-checklist/sidebar-onboarding-checklist.vue";
import SidebarJobSearchPlanStep from "./job-search-plan/job-search-plan-step.vue";

import HelpIcon from '../icons/help'
import ClipSidebarIcon from "../icons/clip-sidebar.vue"

import {
    ChatBubbleBottomCenterTextIcon,
    ArrowRightStartOnRectangleIcon,
} from "@heroicons/vue/24/outline"

import {
		UserPlusIcon
} from "@heroicons/vue/24/solid"

const emit = defineEmits(['new-resource'])

const route = useRoute()
const router = useRouter()

const { getUser, userHaveAccessTo, isAuthenticated } = setAuthState()
const { links } = useMenuItems();

const bulletGenerator = useBulletGenerator();
const subscriptionPlanStore = useSubscriptionPlanStore();
const featuresUsageStore = useFeatureUsageStore();
const sidebarStore = useSidebarStore();
const authPopupStore = useAuthPopupStore();

const { collapsed } = storeToRefs(sidebarStore)
const { isSubscribe } = storeToRefs(subscriptionPlanStore)

const visibleSurvey = ref()
const visibleReferalModal = ref()
const activeRoute = ref(route.name)

const createNewResumeHandler = () => {
	if(isAuthenticated()){
		emit('new-resource');
	}else{
		authPopupStore.setShowAuthPopup();
	}
}

const startNewInterviewHandler = () => {
  if(
      useFeatureUsageStore().fetchFeatureUsage('interview')?.usage == null
      || (useFeatureUsageStore().fetchFeatureUsage('interview')?.usage === 0 && !isSubscribe.value)
  ) {
    featuresUsageStore.setShowLimitExceed('interview');
    return
  }
   
  router.replace({name: 'interview-ai-create', force: true})
}

const handleCloseSurvey = () => {
    visibleSurvey.value = false
}

const handleHome = () => {
	router.push('/')
}

const handleOnboarding = () => {
    bulletGenerator?.showOnboardingFn?.()
}

const showApplicationModal = () => {
    if (!isSubscribe.value) {
        return featuresUsageStore.setShowLimitExceed('auto_apply');
    } else {
        router.push('/auto-apply/search')
    }
}

const showCollapseButton = computed(() => {
	return ['resumes.edit', 'cover-letters.edit'].indexOf(route.name) === -1
})

watch(() => route.name, async newName => {
    activeRoute.value = newName
})
</script>

<style>
.sidebar-divider {
    margin: 16px 0;
    width: 100%;
    height: 1px;
    background-color: #E9EEF2;
}
</style>
